var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink48Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.49 14.6006C25.68 13.4106 27.26 12.7506 28.94 12.7506C30.62 12.7506 32.21 13.4106 33.43 14.6306C35.89 17.0906 35.89 21.0806 33.43 23.5406L29.72 27.2506L32.12 29.6506L35.83 25.9406C39.61 22.1606 39.61 16.0006 35.79 12.1906C33.96 10.3606 31.52 9.35059 28.93 9.35059C26.34 9.35059 23.9 10.3606 22.07 12.1906L18.36 15.9006L20.76 18.3006L24.47 14.5906L24.49 14.6006Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.47 33.5106C21.01 35.9706 17.02 35.9706 14.56 33.5106L14.53 33.4706C13.34 32.2806 12.68 30.7006 12.68 29.0106C12.68 27.3206 13.34 25.7506 14.53 24.5606L18.24 20.8506L15.84 18.4506L12.13 22.1606C10.3 23.9906 9.29004 26.4306 9.29004 29.0206C9.29004 31.6106 10.3 34.0506 12.12 35.8606L12.15 35.9006L12.17 35.9206C14.06 37.8106 16.55 38.7606 19.03 38.7606C21.51 38.7606 24 37.8106 25.89 35.9206L29.6 32.2106L27.2 29.8106L23.49 33.5206L23.47 33.5106Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2675 18.3511L18.266 27.3525L20.6702 29.7567L29.6716 20.7552L27.2675 18.3511Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink48Line);
export default __webpack_public_path__ + "static/media/icon_link_48_line.8e45e0040f2344ea4e7b700cea5c0055.svg";
export { ForwardRef as ReactComponent };